import { ActiveCompanyGuard } from "@/shared/lib/active-company/active-company-guard";
import { ActiveCompanyProvider } from "@/shared/lib/active-company/active-company-provider";
import { AuthProvider } from "@/shared/lib/authorization/auth-provider";
import { store } from "@/shared/lib/store/store";
import * as DevCycleModule from "@devcycle/openfeature-react-provider";
import {
  NOOP_PROVIDER,
  OpenFeature,
  OpenFeatureProvider,
} from "@openfeature/react-sdk";
import * as Sentry from "@sentry/react";
import "@xyflow/react/dist/style.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import "./instrument";

if (import.meta.env.VITE_ENV === "local") {
  OpenFeature.setProvider(NOOP_PROVIDER);
} else {
  // temporary necessary because devcycle does not export esm
  const DevCycleReactProvider =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (DevCycleModule.default as any).default ?? DevCycleModule.default;
  const key = import.meta.env.VITE_DEV_CYCLE_KEY;
  OpenFeature.setProvider(new DevCycleReactProvider(key));
}

createRoot(document.getElementById("root")!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler(),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <OpenFeatureProvider>
          <ActiveCompanyProvider>
            <ActiveCompanyGuard>
              <App />
            </ActiveCompanyGuard>
          </ActiveCompanyProvider>
        </OpenFeatureProvider>
      </AuthProvider>
    </Provider>
  </StrictMode>,
);
